import PropTypes from "prop-types";
import React from "react";

import Star from "./Star";
import styles from "./Rating.css";

const getStarClass = (index, rating) => {
  if (index > rating && index - 1 < rating) {
    return "half";
  } else if (rating >= index) {
    return "full";
  } else {
    return "empty";
  }
};

const generateStars = (rating, size, isLMN) => {
  const roundRating = Math.round(rating * 2) / 2;
  const range = [1, 2, 3, 4, 5];

  return range.map((i) => {
    const filling = getStarClass(i, roundRating);

    return (
      <Star
        key={i}
        value={i}
        type={size}
        isLMN={isLMN}
        filled={filling}
      />
    );
  });
};

const Rating = ({ rating, size = null, isLMN = false, showRatingValue = false }) => {
  const stars = generateStars(rating, size, isLMN);
  const displayRating = (Math.round(rating * 10) / 10).toFixed(1);

  return (
    <span>
      {showRatingValue ? (<span className={styles.displayRating}>{displayRating}</span>) : null}
      {stars}
    </span>
  );
};

Rating.propTypes = {
  rating: PropTypes.number,
  size: PropTypes.string,
  isLMN: PropTypes.bool,
  showRatingValue: PropTypes.bool
};

export default Rating;
